import SvgIcon from '@mui/material/SvgIcon'
import { forwardRef } from 'react'

const Icon = forwardRef(({ component, ...props }, ref) => <SvgIcon component={component} ref={ref} {...props} />)
Icon.displayName = 'Icon'

Icon.defaultProps = {
	...SvgIcon.defaultProps,
	viewBox: '0 0 24 24',
	fontSize: 'medium',
	width: 24,
	height: 24,
}
Icon.propTypes = {
	...SvgIcon.PropTypes,
}

export default Icon
